<template>
<OIconAsync v-if="mode === 'ssr'" v-bind="props" />
<OIconSync v-else v-bind="props" />
</template>

<script setup lang="ts">
import OIconAsync from './Icon/OIconAsync.vue';
import OIconSync, { type OIconProps } from './Icon/OIconSync.vue';

const props = defineProps<OIconProps>();

const mode = typeof window === 'undefined' ? 'ssr' : 'default';
</script>
